var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "inward"
  }, [_c('div', {
    staticClass: "animated fadeInDown"
  }, [_c('form', {
    attrs: {
      "autocomplete": "off"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('b-tabs', {
    model: {
      value: (_vm.tabIndex),
      callback: function($$v) {
        _vm.tabIndex = $$v
      },
      expression: "tabIndex"
    }
  }, [_c('b-tab', {
    staticClass: "show",
    attrs: {
      "title": _vm.$t('packingb2b.tab1'),
      "active": ""
    },
    on: {
      "click": _vm.resetForm
    }
  }, [(_vm.showeye1 == true) ? _c('div', [_c('b-card', [(_vm.css1) ? _c('div', {
    staticStyle: {
      "margin-top": "-4px"
    },
    slot: "header"
  }, [_c('span', {
    staticClass: "mdltitle",
    staticStyle: {
      "color": "rgb(255 112 8)",
      "font-size": "15px"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('boxList.b2bBoxQc')))])])]) : _vm._e(), _vm._v(" "), (_vm.css2) ? _c('div', {
    staticStyle: {
      "margin-top": "-6px"
    },
    slot: "header"
  }, [_c('span', {
    staticClass: "mdltitle",
    staticStyle: {
      "color": "rgb(255 112 8)",
      "font-size": "15px"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('boxList.b2bBoxQc')))])]), _vm._v(" "), (_vm.showBoxDetails) ? _c('span', {
    staticClass: "clientnamecss",
    staticStyle: {
      "top": "0px",
      "left": "118px"
    }
  }, [_vm._v(_vm._s(_vm.$t('boxList.orderOrigin')) + " :\n                  "), (_vm.showBoxDetails) ? _c('span', {
    staticStyle: {
      "color": "rgb(174 45 14)"
    }
  }, [_vm._v(_vm._s(this.finalObject.orderType))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.showBoxDetails) ? _c('span', {
    staticClass: "clientnamecss",
    staticStyle: {
      "left": "171px",
      "top": "0px"
    }
  }, [_vm._v(_vm._s(_vm.$t('client.clientName')) + " : "), (_vm.showBoxDetails) ? _c('span', {
    staticStyle: {
      "color": "rgb(174 45 14)"
    }
  }, [_vm._v(_vm._s(this.finalObject.clientName))]) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.css3) ? _c('div', {
    staticStyle: {
      "margin-top": "-8px"
    },
    slot: "header"
  }, [_c('span', {
    staticClass: "mdltitle",
    staticStyle: {
      "color": "rgb(255 112 8)",
      "font-size": "15px"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('boxList.boxQc')))])]), _vm._v(" "), (_vm.showBoxDetails) ? _c('span', {
    staticClass: "clientnamecss",
    staticStyle: {
      "top": "0px",
      "left": "118px"
    }
  }, [_vm._v(_vm._s(_vm.$t('boxList.orderOrigin')) + " :\n                  "), (_vm.showBoxDetails) ? _c('span', {
    staticStyle: {
      "color": "rgb(174 45 14)"
    }
  }, [_vm._v(_vm._s(this.finalObject.orderType))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.showBoxDetails) ? _c('span', {
    staticClass: "clientnamecss",
    staticStyle: {
      "left": "172px",
      "top": "0px"
    }
  }, [_vm._v(_vm._s(_vm.$t('client.clientName')) + ":"), (_vm.showBoxDetails) ? _c('span', {
    staticStyle: {
      "color": "rgb(174 45 14)"
    }
  }, [_vm._v(_vm._s(this.finalObject.clientName))]) : _vm._e()]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('b-card', [_c('div', {
    slot: "header"
  }, [_c('span', {
    staticClass: "clientnamecss",
    staticStyle: {
      "left": "2px",
      "top": "-3px",
      "width": "315px"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$t('boxList.boxProductDetails')) + "\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('b-card', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-5",
    slot: "header"
  }, [_c('span', {
    staticClass: "mdltitle",
    staticStyle: {
      "color": "rgb(255 112 8)",
      "font-size": "15px"
    }
  }, [_c('b', [_vm._v(" " + _vm._s(_vm.$t('packingb2b.pickingBox')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row",
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between"
    }
  }, [_c('div', {
    staticClass: "col-md-12 row"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('b-form-fieldset', [_c('b-input-group', [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('min_value:1'),
      expression: "'min_value:1'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('boxid')
    },
    attrs: {
      "keyup.native.enter": "fgetBoxDetails",
      "type": "number",
      "placeholder": _vm.$t('supportRequest.boxIDPlaceHolder'),
      "name": "boxid",
      "id": "boxid",
      "min": "1"
    },
    model: {
      value: (_vm.finalObject.pickingboxId),
      callback: function($$v) {
        _vm.finalObject.pickingboxId = $$v
      },
      expression: "finalObject.pickingboxId"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 row",
    staticStyle: {
      "display": "flex",
      "justify-content": "space-around"
    }
  }, [_c('div', {
    staticClass: "col-md-4",
    staticStyle: {
      "margin-left": "-25px",
      "float": "left"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.isLoading || _vm.isLoadingFeild,
      "type": "button",
      "id": "submitbtn",
      "size": "sm",
      "variant": "success"
    },
    on: {
      "click": function($event) {
        _vm.getBoxDetails()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('boxList.getBoxDetailsButton')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "disabled": _vm.isLoading || _vm.isLoadingFeild,
      "type": "button",
      "size": "sm"
    },
    on: {
      "click": _vm.resetForm
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" " + _vm._s(_vm.$t('common.resetBtn')))])])])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('boxid')),
      expression: "errors.has('boxid')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('boxid')))])]), _vm._v(" "), (_vm.showorderDetails) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "col-md-6",
    staticStyle: {
      "margin-bottom": "10px",
      "margin-left": "-15px"
    }
  }, [_c('span', {
    staticClass: "mdltitle",
    staticStyle: {
      "color": "rgb(119, 118, 118)",
      "font-size": "15px"
    }
  }, [_c('b', [_vm._v(" " + _vm._s(_vm.$t('orders.orderDetails')))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row",
    staticStyle: {
      "margin": "0px",
      "display": "flex",
      "justify-content": "left"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('common.client')) + " : ")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(this.finalObject.clientName))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row",
    staticStyle: {
      "margin": "0px",
      "display": "flex",
      "justify-content": "left"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('common.salesChannel')) + " : ")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(this.finalObject.salesChannel))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row",
    staticStyle: {
      "margin": "0px",
      "display": "flex",
      "justify-content": "left"
    }
  }, [_c('label', [_vm._v(" " + _vm._s(_vm.$t('common.orderID')) + " : ")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(this.finalObject.orderId))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row",
    staticStyle: {
      "margin": "0px",
      "display": "flex",
      "justify-content": "left"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('orders.orderQuantity')) + " :")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(this.finalObject.totalOrderQty))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row",
    staticStyle: {
      "margin": "0px",
      "display": "flex",
      "justify-content": "left"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('boxList.selfShipped')) + " :")]), _vm._v(" "), (_vm.finalObject.orderSelfshipped == 1) ? _c('p', [_vm._v(" Yes")]) : _vm._e(), _vm._v(" "), (_vm.finalObject.orderSelfshipped == 0) ? _c('p', [_vm._v(" No")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.showorderDetails) ? _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticStyle: {
      "height": "340px",
      "width": "300px",
      "overflow": "scroll"
    }
  }, [_c('Boxtable', {
    attrs: {
      "box": _vm.box,
      "qty": _vm.allremainingpickqty
    }
  })], 1)]) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 mx-4"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('span', {
    staticClass: "mdltitle",
    staticStyle: {
      "color": "rgb(255 112 8)",
      "font-size": "15px"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('boxList.packingBox')))])])]), _vm._v(" "), (!_vm.showpackingboxdetails) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('b-form-fieldset', [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ispickingbox),
      expression: "ispickingbox"
    }],
    attrs: {
      "type": "checkbox",
      "id": "ispickingbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.ispickingbox) ? _vm._i(_vm.ispickingbox, null) > -1 : (_vm.ispickingbox)
    },
    on: {
      "change": function($event) {
        _vm.selectpickingbox()
      },
      "__c": function($event) {
        var $$a = _vm.ispickingbox,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.ispickingbox = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.ispickingbox = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.ispickingbox = $$c
        }
      }
    }
  })]), _c('span', {
    attrs: {
      "for": "Color mismatched"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('packingb2b.checkBox')))])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group "
  }, [_c('div', {
    staticClass: "col-md-13 row",
    staticStyle: {
      "margin-left": "-30px"
    }
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-input-group', [_c('b-form-input', {
    class: {
      'form-control': true,
      'error': _vm.errors.has('packingboxid')
    },
    attrs: {
      "type": "text",
      "name": "packingboxid",
      "id": "packingboxid",
      "min": "1",
      "placeholder": _vm.$t('ShippingDetails.boxIDPlaceHolder')
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.getBoxDetails($event)
      }
    },
    model: {
      value: (_vm.finalObject.packingboxId),
      callback: function($$v) {
        _vm.finalObject.packingboxId = $$v
      },
      expression: "finalObject.packingboxId"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "disabled": _vm.isLoading || _vm.isLoadingFeild,
      "type": "button",
      "size": "sm"
    },
    on: {
      "click": _vm.scanBox
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(_vm._s(_vm.$t('boxList.scan')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "disabled": _vm.isLoading || _vm.isLoadingFeild,
      "type": "button",
      "size": "sm"
    },
    on: {
      "click": _vm.resetpackingform
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(_vm._s(_vm.$t('common.resetBtn')))])]), _vm._v("\n                        \n                      "), (_vm.isGeneratePackingSlip == true) ? _c('div', {
    staticClass: "col-md-5"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "disabled": _vm.isLoading || _vm.isLoadingFeild,
      "type": "button",
      "size": "sm"
    },
    on: {
      "click": _vm.generatePackingBoxSlip
    }
  }, [_c('i', {
    staticClass: "fa fa-print"
  }), _vm._v(" " + _vm._s(_vm.$t('boxList.packingSlip')))])]) : _vm._e(), _vm._v(" "), (_vm.showpackingboxdetails) ? _c('div', {
    staticStyle: {
      "overflow": "auto",
      "margin-top": "15px"
    }
  }, [_c('table', {
    staticClass: "table-container",
    attrs: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_c('div', {
    staticClass: "scroll-container"
  }, [_c('table', [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('span', [_c('b', [_vm._v(_vm._s(_vm.$t('packingb2b.b2bPacking.modal.boxID')))])])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('span', [_c('b', [_vm._v(_vm._s(_vm.$t('packingb2b.b2bPacking.modal.totalSKUQuantity')))])])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('span', [_c('b', [_vm._v(_vm._s(_vm.$t('packingb2b.b2bPacking.modal.weight')))])])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('span', [_c('b', [_vm._v(_vm._s(_vm.$t('packingb2b.b2bPacking.modal.dimensions')))])])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('span', [_c('b', [_vm._v(" " + _vm._s(_vm.$t('common.print')))])])])])]), _vm._v(" "), _vm._l((_vm.listboxdata), function(data, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center",
      attrs: {
        "width": "10%"
      }
    }, [_c('span', [_vm._v(" " + _vm._s(data.boxid) + " ")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      attrs: {
        "width": "10%"
      }
    }, [_c('span', [_vm._v(_vm._s(data.qty))])]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      attrs: {
        "width": "10%"
      }
    }, [_c('span', [_vm._v(" " + _vm._s(data.weight) + " ")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      attrs: {
        "width": "10%"
      }
    }, [_c('span', [_c('p', [_vm._v(_vm._s(data.length) + "x" + _vm._s(data.width) + "x" + _vm._s(data.height))])])]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      attrs: {
        "width": "10%"
      }
    }, [_c('button', {
      staticClass: "btn btn-success",
      attrs: {
        "disabled": _vm.isLoading || _vm.isLoadingFeild,
        "type": "button",
        "size": "sm"
      },
      on: {
        "click": function($event) {
          _vm.generatePackingBoxSlip1(data.boxid)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-print"
    }), _vm._v(" " + _vm._s(_vm.$t('boxList.packingSlip')) + " ")])])])
  }), _vm._v(" "), (_vm.listboxdata.length == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "4",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.table.noRecordFoundMsg')))])]) : _vm._e()], 2)])])])])]) : _vm._e(), _vm._v(" "), (_vm.showpackingboxdetails) ? _c('div', {
    staticClass: "col-md-12 row my-4"
  }, [(_vm.Qccomplete.remainingqty == 0 && _vm.Qccomplete.b2b_qc_done == 2 && !_vm.Qccomplete.pickingboxpending) ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": [function($event) {
        _vm.adddetails()
      }, function($event) {
        _vm.tabIndex++
      }]
    }
  }, [_vm._v(_vm._s(_vm.$t('boxList.addShipdetails')))])]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [(_vm.showpackingbox) ? _c('div', {
    staticClass: "col-md-13 "
  }, [_c('b-card', [_c('div', {
    slot: "header"
  }, [_c('span', {
    staticClass: "clientnamecss",
    staticStyle: {
      "left": "2px",
      "top": "-3px",
      "width": "480px",
      "display": "flex",
      "justify-content": "space-around"
    }
  }, [_c('div', [_vm._v(" " + _vm._s(_vm.$t('packingb2b.productOutQC')))]), _vm._v(" "), (_vm.b2bPieceLevelPacking == false) ? _c('div', [_vm._v("Scan Manual Qty")]) : _c('div'), _vm._v(" "), (_vm.b2bPieceLevelPacking == false) ? _c('div', {
    on: {
      "click": _vm.resetEmotes
    }
  }, [_c('label', {
    staticClass: "clientnamecss switch1"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "id": "checkbox2",
      "name": "id1"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "slider1 round1"
  })])]) : _c('div'), _vm._v(" "), (_vm.specialInstructionButton == true) ? _c('button', {
    staticClass: "btn btn-success",
    staticStyle: {
      "margin-top": "0.5px",
      "padding": "5px"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.getSpecialInstructionModal()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('config.specialInstructions')))]) : _vm._e()])]), _vm._v(" "), (_vm.showproductdetail) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('b-input-group', [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('min_value:1'),
      expression: "'min_value:1'"
    }],
    ref: "checkProductid",
    class: {
      'form-control': true,
      'error': _vm.errors.has('productid')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('common.productID'),
      "name": "productid",
      "id": "productid",
      "min": "1"
    },
    nativeOn: {
      "keydown": [function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        $event.preventDefault();
        _vm.scanProduct($event)
      }, function($event) {
        _vm.detectKeyPressEventupdate($event)
      }]
    },
    model: {
      value: (_vm.finalObject.productid),
      callback: function($$v) {
        _vm.finalObject.productid = $$v
      },
      expression: "finalObject.productid"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "disabled": _vm.isLoading || _vm.isLoadingFeild,
      "type": "button",
      "size": "sm"
    },
    on: {
      "click": _vm.scanProduct
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(_vm._s(_vm.$t('boxList.scan')))])]), _vm._v(" "), (_vm.isBulkQty) ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-input-group', [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('min_value:1'),
      expression: "'min_value:1'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('Quantity')
    },
    attrs: {
      "type": "number",
      "placeholder": _vm.$t('boxList.quantity'),
      "name": "Quantity",
      "id": "Quantity",
      "min": "1"
    },
    model: {
      value: (_vm.finalObject.productQty),
      callback: function($$v) {
        _vm.finalObject.productQty = $$v
      },
      expression: "finalObject.productQty"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-1",
    staticStyle: {
      "margin-left": "-12px"
    }
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "size": "sm"
    },
    on: {
      "click": _vm.resetProduct
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  })])]), _vm._v(" "), (_vm.validproduct) ? _c('table', {
    staticClass: "table-bordered datatables cardtable my-3",
    attrs: {
      "id": "my-table"
    }
  }, [_c('thead', {
    staticClass: "theader"
  }, [_c('tr', {
    staticClass: "text-primary cardreporttablerow"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('product.productImage')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('product.productName')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.brand')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('product.table.columns.mrp')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('product.table.columns.size')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('product.table.columns.color')))])])])]), _vm._v(" "), _c('tbody', [_c('tr', [(_vm.finalObject.scanproductData.productimage) ? _c('td', {
    staticClass: "text-center"
  }, [_c('img', {
    attrs: {
      "src": _vm.finalObject.scanproductData.productimage,
      "width": "100px",
      "height": "120px"
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.finalObject.scanproductData.productimage) ? _c('td', {
    staticClass: "text-center"
  }, [_c('img', {
    attrs: {
      "src": "static/img/noimg.png",
      "width": "100px",
      "height": "120px"
    }
  })]) : _vm._e(), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(this.finalObject.scanproductData.productname))]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(this.finalObject.scanproductData.brand))]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(this.finalObject.scanproductData.mrp))]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(this.finalObject.scanproductData.size))]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(this.finalObject.scanproductData.color))])])])]) : _vm._e(), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.validproduct) ? _c('div', {
    staticClass: "form-group row my-2"
  }, [(!_vm.isrejectQc) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "disabled": _vm.isLoading || _vm.isLoadingFeild,
      "type": "button",
      "size": "sm"
    },
    on: {
      "click": function($event) {
        _vm.productQC('accept')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('receivedEmail.accept')))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [(!_vm.isrejectQc) ? _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "disabled": true,
      "type": "button",
      "size": "sm"
    },
    on: {
      "click": _vm.rejectQc
    }
  }, [_vm._v(_vm._s(_vm.$t('receivedEmail.reject')))]) : _vm._e(), _vm._v(" "), (_vm.isrejectQc) ? _c('b', [_vm._v(_vm._s(_vm.$t('shipment.rejectedReasons')) + ": ")]) : _vm._e()]), _vm._v(" "), (_vm.isrejectQc) ? _c('div', {
    staticClass: "col-md-8"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.rejectOptions,
      "multiple": true,
      "hide-selected": true,
      "preserve-search": true,
      "clear-on-select": false
    },
    model: {
      value: (_vm.rejectReason),
      callback: function($$v) {
        _vm.rejectReason = $$v
      },
      expression: "rejectReason"
    }
  }), _vm._v(" "), (_vm.rejectReasonErrors) ? _c('label', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.rejectReasonErrors))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.isrejectQc) ? _c('button', {
    on: {
      "click": _vm.resetreject
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  })]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group row my-4"
  }, [_c('div', {
    staticClass: "col-md-7"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card-headerfrm ",
    staticStyle: {
      "height": "250px",
      "width": "250px",
      "overflow": "scroll"
    }
  }, [_c('Boxtable', {
    attrs: {
      "box": _vm.packingboxData,
      "qty": _vm.totalboxqty
    }
  })], 1)])]), _vm._v(" "), ((_vm.packingclose && _vm.packingboxData.length > 0) || (!_vm.packingclose && _vm.Qccomplete.b2b_qc_done != 2 && _vm.orderQcdone && _vm.pickboxcount > 1)) ? _c('div', {
    staticClass: "col-md-5"
  }, [_c('span', {
    staticClass: "clientnamecss",
    staticStyle: {
      "left": "2px",
      "top": "-3px",
      "width": "480px"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('packingb2b.packingBoxClose')) + ": ")])]), _vm._v(" "), _c('b-input-group', [_c('b-form-input', {
    class: {
      'form-control': true,
      'error': _vm.errors.has('packingbox')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('packingb2b.packingBoxId'),
      "name": "packingbox",
      "id": "valpackingbox",
      "min": "1"
    },
    model: {
      value: (_vm.finalObject.valpackingbox),
      callback: function($$v) {
        _vm.finalObject.valpackingbox = $$v
      },
      expression: "finalObject.valpackingbox"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "my-1"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "disabled": _vm.isLoading || _vm.isLoadingFeild,
      "type": "button",
      "size": "sm"
    },
    on: {
      "click": _vm.closeboxQc
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(_vm._s(_vm.$t('boxList.scan')))])])], 1) : _vm._e(), _vm._v(" "), (!_vm.packingclose && _vm.pickboxcount == 1) ? _c('div', {
    staticClass: "col-md-5"
  }, [_c('span', {
    staticClass: "mdltitle",
    staticStyle: {
      "color": "rgb(255 112 8)",
      "font-size": "17px"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('packingb2b.qcAlreadyDone')))])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group row my-4",
    staticStyle: {
      "display": "flex"
    }
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-input-group', [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('min_value:1'),
      expression: "'min_value:1'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('boxid')
    },
    attrs: {
      "type": "number",
      "placeholder": _vm.$t('packingReportList.table.columns.PackingBoxWeight'),
      "name": "boxid",
      "id": "boxid",
      "min": "1"
    },
    model: {
      value: (_vm.finalObject.boxWeight),
      callback: function($$v) {
        _vm.finalObject.boxWeight = $$v
      },
      expression: "finalObject.boxWeight"
    }
  })], 1), _vm._v(" "), _c('br')], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2",
    staticStyle: {
      "margin-left": "-22px"
    }
  }, [_c('button', {
    staticClass: "btn btn-warning",
    staticStyle: {
      "padding": "5px",
      "margin": "0px"
    },
    attrs: {
      "disabled": _vm.isLoading || _vm.isLoadingFeild,
      "type": "button",
      "size": "sm"
    },
    on: {
      "click": _vm.getWeight
    }
  }, [_vm._v(_vm._s(_vm.$t('boxList.getWeightButton')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('b-input-group', [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('min_value:1'),
      expression: "'min_value:1'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('Length')
    },
    attrs: {
      "type": "number",
      "placeholder": _vm.$t('boxList.length'),
      "id": "Length",
      "min": "1"
    },
    model: {
      value: (_vm.finalObject.length),
      callback: function($$v) {
        _vm.finalObject.length = $$v
      },
      expression: "finalObject.length"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('b-input-group', [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('min_value:1'),
      expression: "'min_value:1'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('boxid')
    },
    attrs: {
      "type": "number",
      "placeholder": _vm.$t('boxList.width'),
      "name": "width",
      "id": "width",
      "min": "1"
    },
    model: {
      value: (_vm.finalObject.width),
      callback: function($$v) {
        _vm.finalObject.width = $$v
      },
      expression: "finalObject.width"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('b-input-group', [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('min_value:1'),
      expression: "'min_value:1'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('boxid')
    },
    attrs: {
      "type": "number",
      "placeholder": _vm.$t('boxList.height'),
      "name": "boxid",
      "id": "boxid",
      "min": "1"
    },
    model: {
      value: (_vm.finalObject.height),
      callback: function($$v) {
        _vm.finalObject.height = $$v
      },
      expression: "finalObject.height"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 row",
    staticStyle: {
      "display": "flex",
      "justify-content": "space-around"
    }
  }, [_c('div', {
    staticClass: "col-md-10"
  }, [_c('p', [_c('button', {
    staticClass: "tooltip-tarjet",
    staticStyle: {
      "border": "10px"
    }
  }, [_c('i', {
    staticClass: "fa fa-info",
    staticStyle: {
      "padding": "0px",
      "margin": "0px"
    },
    attrs: {
      "data-toggle": "tooltip",
      "title": "Tool Tip!"
    }
  })]), _c('b', [_vm._v(_vm._s(_vm.$t('packingb2b.note')) + ":")]), _vm._v(_vm._s(_vm.$t('packingb2b.weightInKg')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2",
    staticStyle: {
      "margin-right": "-15px"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    staticStyle: {
      "padding": "5px",
      "margin": "0px"
    },
    attrs: {
      "disabled": _vm.isLoading || _vm.isLoadingFeild,
      "type": "button",
      "size": "sm"
    },
    on: {
      "click": _vm.lbhupdateb2b
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(_vm._s(_vm.$t('common.saveBtn')))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 row"
  }, [(_vm.Qccomplete.remainingqty == 0 && _vm.Qccomplete.b2b_qc_done == 2 && !_vm.Qccomplete.pickingboxpending) ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": [function($event) {
        _vm.adddetails()
      }, function($event) {
        _vm.tabIndex++
      }]
    }
  }, [_vm._v(_vm._s(_vm.$t('boxList.addShipdetails')))])]) : _vm._e()])])])], 1) : _vm._e()])])])])], 1) : _vm._e()]), _vm._v(" "), _c('b-tab', {
    staticClass: "show",
    attrs: {
      "title": _vm.$t('packingb2b.tab2'),
      "active": ""
    },
    on: {
      "click": _vm.resetForm
    }
  }, [_c('section', {
    staticClass: "grcreport"
  }, [_c('loader', {
    attrs: {
      "isLoading": _vm.isLoading
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "animated fadeInDown"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 mb-1"
  }, [_c('div', {
    staticClass: "card-header filter_main"
  }, [_c('i', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.collapse1",
      modifiers: {
        "collapse1": true
      }
    }],
    staticClass: " fa fa-filter filter",
    attrs: {
      "data-toggle": "collapse",
      "aria-expanded": "true"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card-actions"
  })]), _vm._v(" "), _c('b-collapse', {
    attrs: {
      "visible": "",
      "id": "collapse1"
    }
  }, [_c('b-card', [_c('div', {
    staticClass: "card-body1"
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "action": "",
      "method": "post"
    }
  }, [(_vm.showSelectClient || _vm.showSelectWarehouse) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('common.orderID')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-user'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('common.orderIDPlaceholder')
    },
    model: {
      value: (_vm.Qccomplete.orderid),
      callback: function($$v) {
        _vm.Qccomplete.orderid = $$v
      },
      expression: "Qccomplete.orderid"
    }
  })], 1)], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3 datepicker"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('packingb2b.b2bPacking.orderCreatedFromDate')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class=' fa fa-calendar-plus-o'></i>"
    }
  }, [_c('date-picker', {
    attrs: {
      "lang": "en",
      "type": "date",
      "placeholder": _vm.$t('common.datePlaceholder'),
      "format": "YYYY-MM-DD"
    },
    model: {
      value: (_vm.Qccomplete.ordercreatedfromdate),
      callback: function($$v) {
        _vm.Qccomplete.ordercreatedfromdate = $$v
      },
      expression: "Qccomplete.ordercreatedfromdate"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 datepicker"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('packingb2b.b2bPacking.orderCreatedToDate')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class=' fa fa-calendar-plus-o'></i>"
    }
  }, [_c('date-picker', {
    attrs: {
      "lang": "en",
      "type": "date",
      "placeholder": _vm.$t('common.datePlaceholder'),
      "format": "YYYY-MM-DD"
    },
    model: {
      value: (_vm.Qccomplete.ordercreatedtodate),
      callback: function($$v) {
        _vm.Qccomplete.ordercreatedtodate = $$v
      },
      expression: "Qccomplete.ordercreatedtodate"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 datepicker"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('packingb2b.b2bPacking.shipbyFromDate')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class=' fa fa-calendar-plus-o'></i>"
    }
  }, [_c('date-picker', {
    attrs: {
      "lang": "en",
      "type": "date",
      "placeholder": _vm.$t('common.datePlaceholder'),
      "format": "YYYY-MM-DD"
    },
    model: {
      value: (_vm.Qccomplete.Shipbyfromdate),
      callback: function($$v) {
        _vm.Qccomplete.Shipbyfromdate = $$v
      },
      expression: "Qccomplete.Shipbyfromdate"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 datepicker"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('packingb2b.b2bPacking.shipbyToDate')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class=' fa fa-calendar-plus-o'></i>"
    }
  }, [_c('date-picker', {
    attrs: {
      "lang": "en",
      "type": "date",
      "placeholder": _vm.$t('common.datePlaceholder'),
      "format": "YYYY-MM-DD"
    },
    model: {
      value: (_vm.Qccomplete.Shipbytodate),
      callback: function($$v) {
        _vm.Qccomplete.Shipbytodate = $$v
      },
      expression: "Qccomplete.Shipbytodate"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.getb2bQcdonelisting()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" " + _vm._s(_vm.$t('common.searchBtn')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": _vm.resetFormlisting
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" " + _vm._s(_vm.$t('common.resetBtn')))])])])])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-headerfrm"
  }, [_c('div', {
    staticClass: "form-group row",
    staticStyle: {
      "height": "20px"
    }
  }, [_c('div', {
    staticClass: "col-md-3 cardlistheader"
  }, [_c('h4', {
    staticClass: "header"
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('packingb2b.b2bPacking.table.title')) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 cardlistheader"
  }, [_c('b', {
    staticStyle: {
      "font-family": "cursive,fantasy"
    }
  }, [_c('i', {
    staticClass: "fa fa-time",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('common.table.heading')) + " - " + _vm._s(this.formattedDate))])]), _vm._v(" "), (_vm.totalRows > 0) ? _c('div', {
    staticClass: "col-md-1.5 cardlistheader"
  }, [_c('b', {
    staticStyle: {
      "color": "green"
    }
  }, [_c('i', {
    staticClass: "fa fa-time",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(_vm._s(_vm.$t('common.table.count')) + " - " + _vm._s(_vm.totalRows))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered datatables cardtable",
    attrs: {
      "id": "my-table"
    }
  }, [_c('thead', {
    staticClass: "theader"
  }, [_c('tr', {
    staticClass: "text-primary cardreporttablerow"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('packingb2b.b2bPacking.table.columns.b2bOrderId')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('packingb2b.b2bPacking.table.columns.orderCreatedDate')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('packingb2b.b2bPacking.table.columns.shippedByDate')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('packingb2b.b2bPacking.table.columns.totalBox')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('packingb2b.b2bPacking.table.columns.orderQty')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('packingb2b.b2bPacking.table.columns.qcDoneQty')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('packingb2b.b2bPacking.table.columns.qcSKU')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('packingb2b.b2bPacking.table.columns.action')))])])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.listb2bQcdone), function(data) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.order_id))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm._f("moment")(data.createddatetime)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm._f("moment")(data.shipbydatetime)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.boxes))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.acceptedqty))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.acceptedqty))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.totalitem))]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      attrs: {
        "data-backdrop": "static",
        "data-keyboard": "false"
      }
    }, [_c('a', {
      staticStyle: {
        "color": "#44b8bd",
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.AddshipmentDetails(data, _vm.res_client, _vm.res_warehouse)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('packingb2b.b2bPacking.addShipDetails')) + " ")])])])
  }))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('pagination', {
    attrs: {
      "total-pages": _vm.totalPage,
      "total": _vm.totalRows,
      "per-page": _vm.pageLimit,
      "current-page": _vm.currentPage
    },
    on: {
      "pagechanged": _vm.onPageChange
    }
  })], 1)])])])], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "packingscreenmodel",
      "title": "packingscreenmodel",
      "size": "lg",
      "no-close-on-backdrop": true
    },
    on: {
      "click": function($event) {
        _vm.showWarning()
      }
    },
    model: {
      value: (_vm.packingscreenmodel),
      callback: function($$v) {
        _vm.packingscreenmodel = $$v
      },
      expression: "packingscreenmodel"
    }
  }, [_c('loader', {
    attrs: {
      "isLoading": _vm.isLoading1
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h6', {
    staticClass: "modal-title"
  }, [_vm._v(" " + _vm._s(_vm.$t('packingb2b.tab2')) + " ")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "packingscreenmodel",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.showWarning()
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('h5', [_vm._v(_vm._s(_vm.$t('orders.orderDetails')))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_vm._v(" " + _vm._s(_vm.$t('common.client')) + ":")]), _vm._v(" "), _c('span', {
    staticClass: "textcolor col-md-4"
  }, [_vm._v(" " + _vm._s(_vm.Qccomplete.client))])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_vm._v(_vm._s(_vm.$t('common.salesChannel')) + ":")]), _vm._v(" "), _c('span', {
    staticClass: "textcolor col-md-4"
  }, [_vm._v(" " + _vm._s(_vm.salesChannel))])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_vm._v(_vm._s(_vm.$t('common.orderID')) + ":")]), _c('span', {
    staticClass: "textcolor col-md-4"
  }, [_vm._v(_vm._s(_vm.addshipdetails.orderId))])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_vm._v(_vm._s(_vm.$t('orders.orderQuantity')) + ": ")]), _c('span', {
    staticClass: "textcolor col-md-4"
  }, [_vm._v(_vm._s(_vm.quantity))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-md-4"
  }, [_vm._v(_vm._s(_vm.$t('packingb2b.b2bPacking.modal.invoiceDetails')))])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "id": "invoiceNo",
      "placeholder": _vm.$t('inwardList.inward.invoiceNo')
    },
    on: {
      "input": _vm.resetErr
    },
    model: {
      value: (_vm.addinvoicedetails.invoiceno),
      callback: function($$v) {
        _vm.addinvoicedetails.invoiceno = $$v
      },
      expression: "addinvoicedetails.invoiceno"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-input', {
    attrs: {
      "type": "number",
      "min": "0",
      "step": "any",
      "oninput": "validity.valid||(value='')",
      "id": "invoiceValue",
      "placeholder": _vm.$t('inwardList.printData.invoiceValue')
    },
    on: {
      "input": _vm.resetErr
    },
    model: {
      value: (_vm.addinvoicedetails.value),
      callback: function($$v) {
        _vm.addinvoicedetails.value = $$v
      },
      expression: "addinvoicedetails.value"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "id": "ewayBill",
      "placeholder": _vm.$t('packingb2b.eWayBillNo')
    },
    on: {
      "input": _vm.resetErr
    },
    model: {
      value: (_vm.addinvoicedetails.ewaybill),
      callback: function($$v) {
        _vm.addinvoicedetails.ewaybill = $$v
      },
      expression: "addinvoicedetails.ewaybill"
    }
  })], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.invoiceErr != '') ? _c('span', {
    staticStyle: {
      "color": "red",
      "padding-left": "10px"
    }
  }, [_vm._v(_vm._s(_vm.invoiceErr))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-md-4"
  }, [_vm._v(_vm._s(_vm.$t('packingb2b.b2bPacking.modal.shipDetails')))])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-input-group', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.finalObject.courierName),
      expression: "finalObject.courierName"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "couriername",
      "id": "couriername"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.finalObject.courierName = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.courierSelected]
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('common.courier')) + " * ")]), _vm._v(" "), _vm._l((_vm.finalObject.salesChannelList), function(courier_obj) {
    return _c('option', {
      domProps: {
        "value": courier_obj.couriername
      }
    }, [_vm._v(_vm._s(courier_obj.couriername))])
  })], 2)])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "id": "awb",
      "placeholder": _vm.$t('packingReportList.awb')
    },
    on: {
      "input": _vm.resetErr
    },
    model: {
      value: (_vm.finalObject.awbNo),
      callback: function($$v) {
        _vm.finalObject.awbNo = $$v
      },
      expression: "finalObject.awbNo"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.shipErr != '') ? _c('span', {
    staticStyle: {
      "color": "red",
      "padding-left": "10px"
    }
  }, [_vm._v(_vm._s(_vm.shipErr))]) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('button', {
    staticClass: "btn btn-success",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "button",
      "id": "savebtn"
    },
    on: {
      "click": _vm.markorderpacked
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('common.saveBtn')))])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('button', {
    staticClass: "btn btn-primary shipinvoice",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.selectType(1)
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('packingb2b.shipLabel')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('button', {
    staticClass: "btn btn-primary shipinvoice",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "button",
      "data-toggle": "modal",
      "data-backdrop": "static",
      "href": "#confirmationmodal"
    },
    on: {
      "click": function($event) {
        _vm.selectType(0)
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('packingb2b.packingList')) + " ")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    key: _vm.listboxdata,
    staticStyle: {
      "height": "75vh",
      "width": "100%"
    }
  }, [_c('packingBoxList', {
    attrs: {
      "box": _vm.listboxdata,
      "qty": _vm.quantity,
      "clientid": _vm.Qccomplete.client,
      "disableflag": _vm.disableflag
    }
  })], 1)])])])])], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "confirmationmodal",
      "title": "Confirmation",
      "data-backdrop": "static",
      "no-close-on-backdrop": true
    },
    model: {
      value: (_vm.modalShowForConfirmType),
      callback: function($$v) {
        _vm.modalShowForConfirmType = $$v
      },
      expression: "modalShowForConfirmType"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h6', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.$t('packingb2b.printPackingSlip')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "confirmationmodal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.modalShowForConfirm
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.papertype),
      expression: "papertype"
    }],
    staticClass: "col-lg-1",
    attrs: {
      "type": "radio",
      "id": "paper",
      "name": "pickingtype",
      "value": "paper"
    },
    domProps: {
      "checked": _vm._q(_vm.papertype, "paper")
    },
    on: {
      "__c": function($event) {
        _vm.papertype = "paper"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "cluster"
    }
  }, [_vm._v(_vm._s(_vm.$t('packingb2b.paper')) + " ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.papertype),
      expression: "papertype"
    }],
    staticClass: "col-lg-1",
    attrs: {
      "type": "radio",
      "id": "sticker",
      "name": "pickingtype",
      "value": "sticker"
    },
    domProps: {
      "checked": _vm._q(_vm.papertype, "sticker")
    },
    on: {
      "__c": function($event) {
        _vm.papertype = "sticker"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "batch"
    }
  }, [_vm._v(_vm._s(_vm.$t('packingb2b.sticker')) + " ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "float-right"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.downloadShipLabel
    }
  }, [_vm._v(_vm._s(_vm.$t('common.print')) + " ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.modalShowForConfirm
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(_vm._s(_vm.$t('common.cancelBtn')) + " ")])])])])])])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "warningmodal",
      "title": "Confirmation",
      "data-backdrop": "static",
      "no-close-on-backdrop": true
    },
    model: {
      value: (_vm.modalShowForWarning),
      callback: function($$v) {
        _vm.modalShowForWarning = $$v
      },
      expression: "modalShowForWarning"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.$t('packingb2b.warning')) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('h6', [_vm._v("  " + _vm._s(_vm.$t('packingb2b.printingImpossibility')) + "  "), _c('br'), _vm._v("\n                " + _vm._s(_vm.$t('packingb2b.printConfirmationMsg')) + "?\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "float-right"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.closeconfirmmodel
    }
  }, [_vm._v(_vm._s(_vm.$t('common.confirm')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.modalcloseForwarning
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" " + _vm._s(_vm.$t('common.cancelBtn')))])])])])])])])], 1)], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "vlg"
    },
    on: {
      "ok": function($event) {
        _vm.closeSpecialInstructionModal = false
      }
    },
    model: {
      value: (_vm.specialInstructionModel),
      callback: function($$v) {
        _vm.specialInstructionModel = $$v
      },
      expression: "specialInstructionModel"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('b-card', [_c('div', {
    slot: "header"
  }, [_c('span', {
    staticClass: "mdltitle"
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('config.specialInstructions')) + " ")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeSpecialInstructionModal
    }
  }, [_vm._v("×")])]), _vm._v(" "), (_vm.specialInstructionCount == 0) ? _c('div', {
    staticClass: "text-center"
  }, [_c('p', [_vm._v(" " + _vm._s(_vm.$t('config.specialInstructionNotFound')))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.specialInstructionList), function(instruction) {
    return (_vm.specialInstructionCount > 0) ? _c('ul', {
      key: instruction.instructionid
    }, [_c('li', [_vm._v("\n                " + _vm._s(instruction.instructionname) + "\n              ")])]) : _vm._e()
  })], 2)], 1)])], 1)])])])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-666a4d0e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-666a4d0e","hasScoped":true}!./src/views/components/packingb2bnew/packingb2bnew.component.html
// module id = 2086
// module chunks = 0